export default __webpack_public_path__ + "static/media/image6.98b45eb4.png";